/**
 * Prints the content of a given HTML element in a new tab and closes the tab after printing or canceling.
 * @param {React.RefObject} contentRef - The ref to the HTML element to be printed.
 * @param {string} title - Optional title for the print window.
 */
const printContent = (contentRef, title = "Print") => {
    if (!contentRef.current) {
        console.error("Invalid content reference.");
        return;
    }

    const printContent = contentRef.current.innerHTML;

    // Open a new tab
    const printWindow = window.open("", "_blank");

    if (!printWindow) {
        console.error("Failed to open a new window/tab.");
        return;
    }

    printWindow.document.open();
    printWindow.document.write(`
        <html>
            <head>
                <title>${title}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; }
                    table { width: 100%; border-collapse: collapse; }
                    table, th, td { border: 1px solid #ccc; }
                    th { background-color: #f5f5f5; }
                    th, td { padding: 8px; text-align: left; }
                    .text-right { text-align: right; }
                    .summary-table { width: 50%; float: right; margin-left: 20px; }
                    .content-wrapper { width: 100%; overflow: hidden; }
                </style>
            </head>
            <body>
                ${printContent}
            </body>
        </html>
    `);
    printWindow.document.close();

    // Focus on the new tab and trigger print
    printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();

        // Use a timeout to close the tab after the print dialog is closed
        const closeCheck = setInterval(() => {
            if (printWindow.closed) {
                clearInterval(closeCheck);
            } else if (printWindow.document.hasFocus() === false) {
                // Close the tab if the user exits the print dialog
                clearInterval(closeCheck);
                printWindow.close();
            }
        }, 500);
    };
};

export const numberFormat = (number, padding = 0) => {
        if (isNaN(number)) {
            return "00"; // Handle invalid input
        }
        // Convert the number to a string and format it with commas
        const numStr = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if( number < 0) {
            // If the number is negative, add parentheses around it and remove the negative sign
            if (numStr.startsWith('-')) {
                return `(${numStr.slice(1)})`;
            }
        }
        // Pad the number with leading zeros if necessary
        return numStr.padStart(padding, '0');
    }

  export const formatDate = (dateString) => {
        // Parse the input date string
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
        // Check if the input contains time (datetime format)
        const hasTime = dateString.includes("T") || dateString.includes(" ");
    
        if (hasTime) {
            // Handle datetime format
            const [datePart, timePart] = dateString.split(/[T ]/); // Split by "T" or space
            const [year, month, day] = datePart.split("-");
            let [hours, minutes] = timePart.split(":");
    
            // Convert hours to 12-hour format and determine AM/PM
            const isPM = parseInt(hours, 10) >= 12;
            hours = (parseInt(hours, 10) % 12) || 12; // Convert 0 or 24-hour to 12-hour format
            const formattedTime = `${hours}:${minutes}${isPM ? "pm" : "am"}`;
    
            // Format the date with time
            return `${day}-${months[parseInt(month, 10) - 1]}-${year} ${formattedTime}`;
        } else {
            // Handle date-only format
            const [year, month, day] = dateString.split("-");
            return `${day}-${months[parseInt(month, 10) - 1]}-${year}`;
        }
    }

export default printContent;
